export enum BitstreamFormatSupportLevel {
  Known = 'KNOWN',
  Unknown = 'UNKNOWN',
  Supported = 'SUPPORTED'
}
